import React from 'react';
import { Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { HERO_SUBTITLE } from '../constants/landingText';

interface HeroSectionSubTitleProps {
  fontSize?: { xs: string; md: string };
  maxWidth?: string;
}

const HeroSectionSubTitle: React.FC<HeroSectionSubTitleProps> = ({
  fontSize = { xs: '18px', md: '20px' },
  maxWidth = '40rem',
}) => {
  return (
    <Typography
      variant="subheading"
      component="h2"
      sx={{
        fontSize,
        fontWeight: 400,
        lineHeight: { xs: '1.5', md: '1.4' },
        color: colors.neutral.white,
        mb: { xs: 5, md: 6 },
        textAlign: 'center',
        maxWidth,
        margin: '0 auto',
        fontFamily: 'Outfit, sans-serif',
      }}
    >
      {HERO_SUBTITLE}
    </Typography>
  );
};

export default HeroSectionSubTitle;
